<template>
  <div>
    <z-header :title="title" :actions="actions"></z-header>
    <div>
      <p class="has-text-right">
        <button @click="exportToCSV" :class="{'is-loading' : isLoading ,'is-primary': true, button: true }" :disabled="data.length == 0">Exportar para CSV</button>
      </p>
    </div>
    <section>
      <h5 class="title is-5">Filtrar</h5>
      <div class="columns is-multiline is-mobile">
        <div class="column is-half-mobile is-one-third-desktop">
          <b-field label="por Placa" label-position="on-border">
            <b-input
              v-model="filters.registrationPlate"
              name="registrationPlate"
              maxlength="8"
              :has-counter="false"
            />
          </b-field>
        </div>
        <div class="column is-half-mobile is-one-third-desktop">
          <b-field label="por Descrição" label-position="on-border">
            <b-input v-model="filters.description" name="description" />
          </b-field>
        </div>
        <div class="column is-half-mobile is-one-third-desktop">
          <b-field label="por Código" label-position="on-border">
            <b-input v-model="filters.externalCode" name="externalCode" />
          </b-field>
        </div>
      </div>
    </section>
    <section>
      <b-table
        :data="filter"
        :hoverable="true"
        :striped="true"
        :row-class="rowClass"
        :mobile-cards="true"
        :loading="isLoading"
        @click="view"
        default-sort="id"
        sort-icon="sort-up"
        :paginated="true"
        :pagination-simple="true"
        aria-next-label="Proxima página"
        aria-previous-label="Página anterior"
        aria-page-label="Página"
        aria-current-label="Página atual"
      >
        <template slot-scope="props">
          <b-table-column field="registrationPlate" label="Placas" sortable>
            <b-tag type="is-info" size="is-small">{{
              props.row.registrationPlate | plate
            }}</b-tag>
          </b-table-column>

          <b-table-column field="description" label="Descrição" sortable>{{
            props.row.description
          }}</b-table-column>

          <b-table-column field="place" label="Localização" sortable>{{
            props.row.place
          }}</b-table-column>

          <b-table-column field="externalCode" label="Cód. interno" sortable>{{
            props.row.externalCode
          }}</b-table-column>
        </template>
        <template slot="empty">
          <section v-if="!isLoading" class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="sad-tear" size="is-large"></b-icon>
              </p>
              <p>Sem dados da frota.</p>
            </div>
          </section>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
import { format } from "date-fns";
import ZHeader from "../../layout/Header";
import fleet from "../../services/fleetVehicle";
import { downloadCSV } from "../../services/downloadCSV";

import "@/filters/registration-plate";
import { registrationPlate } from "../../filters/registration-plate";

export default {
  data() {
    return {
      title: "Veículos",
      actions: [
        {
          label: "Cadastrar",
          route: "veiculos/novo",
          class: "is-primary"
        }
      ],
      data: [],
      filters: {
        registrationPlate: "",
        description: "",
        place: "",
        externalCode: ""
      },
      isLoading: false,
      firstLoad: true
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    filter: function() {
      const cleanPlate = this.filters.registrationPlate.replace(/[^\w]/g, "");
      const plateRegExp = new RegExp(cleanPlate, "i");
      const descriptionRegExp = new RegExp(this.filters.description, "i");
      const placeRegExp = new RegExp(this.filters.place, "i");
      const externalCodeRegExp = new RegExp(this.filters.externalCode, "i");

      return this.data.filter(
        value =>
          value.registrationPlate.match(plateRegExp) &&
          (value.description || "").match(descriptionRegExp) &&
          (value.place || "").match(placeRegExp) &&
          (value.externalCode || "").match(externalCodeRegExp)
      );
    }
  },
  methods: {
    loadData() {
      this.isLoading = true;
      fleet.all().then(data => {
        this.isLoading = false;
        this.data = data;
      });
    },
    view(data) {
      this.$router.push(`veiculos/${data.id}`);
    },

    rowClass() {
      return "is-clickable";
    },
    exportToCSV(e) {
      e.preventDefault();
      
      const header = {
        registrationPlate: "PLACA",
        description: "DESCRIÇÃO",
        externalCode: "CÓDIGO INTERNO",
        place: "LOCALIZAÇÃO"
        
      };
      const allowedCols = Object.keys(header);

      const csv = this.data.map(row =>
        allowedCols.map(col => {
          switch (col) {
            case "registrationPlate":
              return registrationPlate(row.registrationPlate);
            default:
              return row[col]
          }
        }).join(",")
      );
      const file = `${allowedCols.map(h => header[h]).join(",")}\n${csv.join("\n")}`;
      const filename = `extrato-veiculos-zul-corporate-${format(new Date(), "dd-MM-yyyy-HH-mm")}`;
      downloadCSV(file, `${filename}.csv`);
    }
  },
  components: {
    ZHeader
  }
};
</script>

<style lang="scss"></style>
